// src/components/Login.jsx - Working solution without custom tokens
import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebaseConfig';
import logo from '../assets/images/unionIcon.svg';
import _ from "lodash";
import { removeDots } from "@/utils/validation.js";

const Login = (subdomainObj) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [autoSigningIn, setAutoSigningIn] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchParams] = useSearchParams();

    // Check for stored authentication data when component mounts
    useEffect(() => {
        handleStoredAuth();
    }, []);

    const handleStoredAuth = async () => {
        try {
            console.log('-[handleStoredAuth]---->',);
            // Check if we have credentials passed via URL (from main domain)
            const storedCreds = searchParams.get('auth');
            console.log('-[handleStoredAuth]---storedCreds->',storedCreds);
            console.log('-[handleStoredAuth]---auth.currentUser->',auth.currentUser);

            if ( storedCreds  ) {
                setAutoSigningIn(true);
                setError('');

                try {
                    const { email, password, timestamp } = JSON.parse(atob(storedCreds));

                    // Check if the stored auth is not too old (5 minutes max)
                    if (Date.now() - timestamp > 5 * 60 * 1000) {
                        setError('Authentication expired. Please log in again.');
                        // Clear the URL parameter
                        window.history.replaceState({}, document.title, window.location.pathname);
                        return;
                    }

                    console.log('Attempting auto sign-in for:', email);

                    // Sign in with stored credentials using regular Firebase auth
                    await signInWithEmailAndPassword(auth, email, password);

                    // Clear the URL parameter for security
                    window.history.replaceState({}, document.title, window.location.pathname);

                    console.log('Auto sign-in successful');

                    // Navigate to dashboard
                    navigate('/dashboard');
                } catch (parseError) {
                    console.error('Error parsing auth data:', parseError);
                    setError('Invalid authentication data. Please log in again.');
                    // Clear the URL parameter
                    window.history.replaceState({}, document.title, window.location.pathname);
                }
            }else{
                console.log('--storedCreds--->',storedCreds);
                //const { email, password, timestamp } = JSON.parse(atob(storedCreds));

            }
        } catch (err) {
            console.error('Auto sign-in failed:', err);
            //setError('Auto sign-in failed. Please log in manually.');
            // Clear the URL parameter
            window.history.replaceState({}, document.title, window.location.pathname);
        } finally {
            setAutoSigningIn(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Form validation
        if (!email || !password) {
            return setError('Please fill in all fields');
        }

        try {
            setError('');
            setLoading(true);

            // Authenticate the user and load profile
            const user = await login(removeDots(email), password, true); // Skip auto-redirect
            console.log('---AFTER LOGIN, user:', user);

            // Check if we're on the main domain (no subdomain)
            // if (!_.get(subdomainObj, 'subdomain')) {
            //     console.log('---no subdomain, redirecting to group subdomain---');
            //
            //     const hostname = window.location.hostname;
            //     const protocol = window.location.protocol;
            //     const port = window.location.port ? `:${window.location.port}` : '';
            //     const groupName = _.get(user, 'groupName');
            //
            //     if (groupName && groupName !== 'default') {
            //         console.log('Redirecting to group subdomain:', groupName);
            //
            //         // Create base64 encoded auth data for secure URL transfer
            //         const authData = {
            //             email: removeDots(email),
            //             password: password,
            //             timestamp: Date.now()
            //         };
            //
            //         const encodedAuth = btoa(JSON.stringify(authData));
            //
            //         // Redirect to subdomain with auth data
            //         const subdomainUrl = `${protocol}//${groupName.toLowerCase()}.${hostname}${port}/login?auth=${encodedAuth}`;
            //         console.log('Redirecting to:', subdomainUrl);
            //
            //         window.location.href = subdomainUrl;
            //         return; // Exit early since we're redirecting
            //     } else {
            //         console.log('No valid group name found for user, staying on main domain');
            //         navigate('/dashboard');
            //     }
            // } else {
            //     // Already on subdomain, just navigate normally
            //     console.log('Already on subdomain, navigating to dashboard');
                navigate('/dashboard');
            // }
        } catch (err) {
            let errorMessage = 'Failed to log in. Please check your credentials.';

            // Handle specific Firebase errors
            switch (err.code) {
                case 'auth/user-not-found':
                    errorMessage = 'No account found with this email address.';
                    break;
                case 'auth/wrong-password':
                    errorMessage = 'Incorrect password. Please try again.';
                    break;
                case 'auth/invalid-email':
                    errorMessage = 'Please enter a valid email address.';
                    break;
                case 'auth/user-disabled':
                    errorMessage = 'This account has been disabled.';
                    break;
                case 'auth/too-many-requests':
                    errorMessage = 'Too many failed login attempts. Please try again later.';
                    break;
                case 'auth/invalid-credential':
                    errorMessage = 'Invalid credentials. Please check your email and password.';
                    break;
                default:
                    errorMessage = err.message || 'Failed to log in. Please check your credentials.';
            }

            setError(errorMessage);
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    // Show loading state during auto sign-in
    if (autoSigningIn) {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-border mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p>Signing you in...</p>
                </div>
            </Container>
        );
    }

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <div className="w-100" style={{ maxWidth: '400px', borderRadius: '25px' }}>
                <Card>
                    <Card.Body>
                        <div className="d-flex justify-content-center align-items-center mb-4">
                            <img
                                src={logo}
                                alt="KNOKO"
                                style={{maxWidth: '200px', height: 'auto'}}
                            />
                        </div>
                        {error && <Alert variant="danger">{error}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group id="email" className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group id="password" className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <div className="d-flex justify-content-center align-items-center mb-3">
                                <Button
                                    disabled={loading}
                                    type="submit"
                                    style={{ borderRadius: '56px', width:'104px' }}
                                >
                                    {loading ? 'Loading...' : 'Log In'}
                                </Button>
                            </div>

                            <div className="text-center mt-3">
                                <p className="mb-0">
                                    Need an account? <Link to="/signup">Sign Up</Link>
                                </p>
                            </div>

                            <div className="text-center mt-3">
                                <p className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                                    <Link to="/privacy" style={{ textDecoration: 'none' }}>Privacy Policy</Link>
                                    {' • '}
                                    <Link to="/terms" style={{ textDecoration: 'none' }}>Terms of Service</Link>
                                </p>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default Login;